import main from '@football-kids/client-lib/main';
import appTheme, { globalStyles } from './theme';

main({ theme: appTheme, globalStyles });
